<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReservationMealsIndex'
}
</script>
